import { QueryKey, useQueryClient } from '@tanstack/react-query';

const useGraphCache = <T>(key: QueryKey) => {
  const query = useQueryClient();
  const results = query.getQueryCache().find(key);
  return results?.state?.data as T;
};

export default useGraphCache;
